import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e737c640"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "card-header border-0 pt-6" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = {
  class: "d-flex justify-content-end",
  "data-kt-customer-table-toolbar": "base"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body pt-0 compact-table" }
const _hoisted_9 = ["title"]
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "text-gray-700"
}
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  class: "text-gray-600 text-hover-primary mb-1 text-center",
  style: {"font-size":"0.85rem","max-width":"85px"}
}
const _hoisted_15 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_16 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = {
  key: 0,
  class: "text-success text-hover-primary mb-1 text-center",
  style: {"font-size":"0.85rem","max-width":"85px"}
}
const _hoisted_19 = {
  key: 1,
  class: "text-warning text-hover-primary mb-1 text-center",
  style: {"font-size":"0.85rem","max-width":"85px"}
}
const _hoisted_20 = { class: "d-flex align-items-center flex-nowrap" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "svg-icon svg-icon-3" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OfficesAdvancedSearch = _resolveComponent("OfficesAdvancedSearch")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_ctx.can('read', 'users'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_OfficesAdvancedSearch, {
                summary: _ctx.summary,
                onTypeSelected: _ctx.onFilterChange,
                onReset: _ctx.onResetFilters
              }, null, 8, ["summary", "onTypeSelected", "onReset"])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.can('create', 'users'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn btn-primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('offices-creating')))
                  }, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotone/Navigation/Plus.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.translate('addNewOffice')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Datatable, {
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            loading: _ctx.loading,
            "rows-per-page": 10,
            total: _ctx.totalItems,
            "enable-items-per-page-dropdown": false,
            onCurrentChange: _ctx.pageChanged
          }, {
            "cell-id": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.id), 1)
            ]),
            "cell-name": _withCtx(({ row: user }) => [
              _createElementVNode("span", {
                class: "truncatable-cell",
                title: user.name,
                dir: "auto"
              }, _toDisplayString(user.name), 9, _hoisted_9)
            ]),
            "cell-email": _withCtx(({ row: user }) => [
              _createElementVNode("a", {
                href: `mailto:${user.email}`,
                class: "text-gray-600 text-hover-primary mb-1"
              }, _toDisplayString(user.email), 9, _hoisted_10)
            ]),
            "cell-memberTypeLabel": _withCtx(({ row: user }) => [
              _createElementVNode("span", {
                class: _normalizeClass(["badge", _ctx.getMemberTypeBadgeClass(user.memberTypeLabel)])
              }, _toDisplayString(_ctx.translate(user.memberTypeLabel)), 3)
            ]),
            "cell-lastAdDate": _withCtx(({ row: user }) => [
              (user.lastAdDate)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.formatDate(user.lastAdDate)), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString('N/A')))
            ]),
            "cell-totalAds": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.totalAds), 1)
            ]),
            "cell-remainingAds": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.remainingAds), 1)
            ]),
            "cell-createdAt": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.createdAt), 1)
            ]),
            "cell-phone": _withCtx(({ row: user }) => [
              _createTextVNode(_toDisplayString(user.phone), 1)
            ]),
            "cell-badgeIcon": _withCtx(({ row: user }) => [
              _createElementVNode("img", {
                src: user.badgeIcon,
                alt: "Badge Icon",
                class: "img-fluid",
                style: {"max-width":"50px","max-height":"50px"}
              }, null, 8, _hoisted_13),
              _createElementVNode("span", _hoisted_14, _toDisplayString(user.badgeTitle), 1)
            ]),
            "cell-is_active": _withCtx(({ row: user }) => [
              (user.is_active)
                ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.translate('active')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.translate('inactive')), 1))
            ]),
            "cell-verificationIcon": _withCtx(({ row: user }) => [
              _createElementVNode("img", {
                src: user.verificationIcon,
                alt: "Badge Icon",
                class: "img-fluid",
                style: {"max-width":"50px","max-height":"50px"}
              }, null, 8, _hoisted_17),
              (user.isVerifiedOffice)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, " Verified "))
                : (_openBlock(), _createElementBlock("span", _hoisted_19, " Standard "))
            ]),
            "cell-actions": _withCtx(({ row: user }) => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                  onClick: _withModifiers(($event: any) => (_ctx.viewOfficeOverview(user.id)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_22, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                  ])
                ], 8, _hoisted_21),
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                  onClick: _withModifiers(($event: any) => (_ctx.updateOffice(user.id)), ["prevent"])
                }, [
                  _createElementVNode("span", _hoisted_24, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen061.svg" })
                  ])
                ], 8, _hoisted_23)
              ])
            ]),
            _: 1
          }, 8, ["table-data", "table-header", "loading", "total", "onCurrentChange"])
        ])
      ]))
    : _createCommentVNode("", true)
}